import { AlertCircle } from "lucide-react";

type ValidationErrorPanelProps = {
  message?: string;
  validationErrors?: Array<{ loc?: string[]; msg?: string }>;
  onDismiss?: () => void;
};

export function ValidationErrorPanel({ message, validationErrors, onDismiss }: ValidationErrorPanelProps) {
  return (
    <div className="rounded-lg border border-danger/50 bg-danger/5 p-4">
      <div className="flex items-start gap-3">
        <AlertCircle className="h-5 w-5 shrink-0 text-danger" />
        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-semibold text-text">Erreur de validation</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            {message ?? "Les données envoyées sont invalides. Corrigez les champs indiqués."}
          </p>
          {validationErrors && validationErrors.length > 0 && (
            <ul className="mt-2 list-inside list-disc text-sm text-muted-foreground">
              {validationErrors.map((e, i) => (
                <li key={i}>
                  {Array.isArray(e.loc) ? e.loc.join(".") : "champ"}: {e.msg ?? "invalide"}
                </li>
              ))}
            </ul>
          )}
          {onDismiss && (
            <button
              type="button"
              onClick={onDismiss}
              className="mt-3 text-sm font-medium text-accent hover:underline"
            >
              Fermer
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
